class Monitoring.Views.SocialContents.Filters.TextSelectorView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/keywords/text_selector"]

  events:
    'click .add': 'onAdd'
    'keydown': 'onKeydown'

  initialize: (@options = {}) ->
    super(@options)
    @placeholder = @options.placeholder || ""
    @buttonLabel = @options.buttonLabel || "Add"

  render: ->
    @$el.html(@template({
      placeholder: @placeholder
      buttonLabel: @buttonLabel
    }))
    @

  onAdd: ->
    entered_text = @$el.find('input[name="enter"]').val()
    if entered_text != ""
      @trigger('newText', entered_text)
      @render()

  onKeydown: (evt) ->
    keyCode = evt.keyCode || evt.which
    if keyCode == 13  # Enter
      @onAdd()
